import React from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  Text,
  StyleProp,
  ViewStyle,
  TextStyle,
  Platform,
  useWindowDimensions,
} from 'react-native';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import LinearGradient from 'react-native-linear-gradient';

interface IIconTextButtonProps {
  onPress: () => void;
  text?: string;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  gradientStyle?: StyleProp<ViewStyle>;
  icon?: React.ReactNode;
  gradientColor1?: string;
  gradientColor2?: string;
}
const IconTextButton = (props: IIconTextButtonProps) => {
  const {
    onPress,
    text,
    style,
    textStyle,
    containerStyle,
    gradientStyle,
    icon,
    gradientColor1 = '#FF9900',
    gradientColor2 = '#F1BF77',
  } = props;
  const { width } = useWindowDimensions();
  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  return (
    <LinearGradient
      colors={[gradientColor1, gradientColor2]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.gradientBorder, gradientStyle]}
    >
      <TouchableOpacity style={[styles.container, containerStyle]} onPress={onPress}>
        {icon}
        {text && !isMobile && !isMobileWeb && (
          <Text maxFontSizeMultiplier={1} style={[styles.text, textStyle]}>
            {text}
          </Text>
        )}
      </TouchableOpacity>
    </LinearGradient>
  );
};

export { IconTextButton };

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    height: 49,
    borderRadius: 11,
    paddingHorizontal: 10,
  },
  text: {
    fontFamily: 'Secular One',
    fontSize: 22,
    marginLeft: 10,
    marginTop: 4,
    color: '#453B3B',
    fontWeight: '400',
  },
  gradientBorder: {
    borderRadius: 16,
    paddingTop: 0,
    paddingBottom: 2.5,
    paddingRight: 2.5,
    height: 55,
  },
});
